module.exports = __webpack_public_path__ + "img/chambre.cf987fe7.svg";